import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#c7401A',
      dark: '#81240f',
      darker: '#9d200b',
      light: '#c66b4f',
      medium: '#822f21',
    },
    background: {
      default: '#45040c', // Darkest brand color
      paper: '#81240f',   // Dark brand color for cards/papers
    },
    text: {
      primary: '#ffffff',   // Pure white for maximum contrast
      secondary: '#ffd4c8', // Lighter secondary text for better readability
    },
  },
  typography: {
    fontFamily: "'FranxurterTotallyMedium', sans-serif",
    h1: {
      fontWeight: 700,
      fontFamily: "'FranxurterTotallyMedium', serif",
      color: '#ffd4c8', // Lighter color for better contrast on dark backgrounds
    },
    h2: {
      fontWeight: 600,
      fontFamily: "'FranxurterTotallyMedium', serif",
      color: '#ffd4c8', // Lighter color for better contrast on dark backgrounds
    },
    body1: {
      color: '#ffffff', // Pure white for maximum contrast
    },
    body2: {
      color: '#ffffff', // Pure white for maximum contrast
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          backgroundColor: '#c7401A', // Primary brand color
          color: '#ffffff',
          border: '2px dashed #ffd4c8',
          padding: '6px 16px',
          '&:hover': {
            backgroundColor: '#9d200b', // Darker brand color on hover
            border: '2px dashed #ffffff',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
          backgroundColor: '#81240f', // Dark brand color for cards
          color: '#ffffff',
          border: '3px dashed #ffd4c8',
          padding: '2px',
          position: 'relative',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 4,
            left: 4,
            right: 4,
            bottom: 4,
            border: '2px dashed #ffd4c8',
            borderRadius: 8,
            pointerEvents: 'none',
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#9d200b', // Darker brand color for navbar
          borderBottom: '3px dashed #ffd4c8',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#81240f', // Dark brand color for paper components
          color: '#ffffff',
          border: '2px dashed #ffd4c8',
          padding: '16px',
          position: 'relative',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 4,
            left: 4,
            right: 4,
            bottom: 4,
            border: '2px dashed #ffd4c8',
            pointerEvents: 'none',
          },
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: '#ffffff',
          '&:hover': {
            color: '#ffd4c8',
          },
        },
      },
    },
  },
});

// Add custom colors for styled-components
theme.colors = {
  primary: '#c7401A',
  dark: '#81240f',
  darker: '#9d200b',
  darkest: '#45040c',
  light: '#ffd4c8',
  medium: '#822f21',
  text: '#ffffff',
  textSecondary: '#ffd4c8',
};

theme.fonts = {
  heading: "'FranxurterTotallyFat', serif",
  body: "'FranxurterTotallyMedium', sans-serif",
};

export default theme;